import { motion } from "framer-motion";
import { Leaf, PersonStanding, Laptop } from "lucide-react";

export const Reveal = ({ children, delay = 0, className = "", y = 30 }) => (
    <motion.div
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
        className={className}
    >
        {children}
    </motion.div>
);

export const SectionHeading = ({ number, eyebrow, title, sub, center = false, testId }) => (
    <Reveal className={center ? "text-center" : ""}>
        <p className="overline-label" data-testid={testId ? `${testId}-eyebrow` : undefined}>
            {number} <span className="mx-2 text-stone">—</span> {eyebrow}
        </p>
        <h2
            className="mt-5 font-serif text-[clamp(2.1rem,1.2rem+2.4vw,3.9rem)] leading-[1.08] tracking-[-1.2px] text-pine"
            data-testid={testId ? `${testId}-title` : undefined}
        >
            {title}
        </h2>
        {sub && (
            <p className={`mt-5 max-w-xl text-[17px] md:text-lg leading-[1.6] tracking-normal text-sage ${center ? "mx-auto" : ""}`}>
                {sub}
            </p>
        )}
    </Reveal>
);

export const RhythmIcon = ({ slug, className = "h-9 w-9" }) => {
    if (slug === "natura") return <Leaf className={className} strokeWidth={1.25} />;
    if (slug === "cialo") return <PersonStanding className={className} strokeWidth={1.25} />;
    return <Laptop className={className} strokeWidth={1.25} />;
};
